<!-- eslint-disable -->
<template>
  <v-card
    elevation="2"
    class="group-card"
    :class="{ 'cursor-pointer': true }"
    @click="$emit('click', group)"
  >
    <!-- Cover Image -->
    <v-img
      :src="group.coverImageUrl || defaultCover"
      height="120"
      cover
      class="group-cover"
    >
      <div class="group-cover-overlay">
        <v-chip
          v-if="group.userRole"
          :color="roleColor"
          size="small"
          class="ma-2"
        >
          {{ group.userRole }}
        </v-chip>
        <v-chip
          v-if="!group.isPublic"
          color="grey"
          size="small"
          class="ma-2"
        >
          <v-icon start size="small">mdi-lock</v-icon>
          {{ $t('groups.private') }}
        </v-chip>
      </div>
    </v-img>

    <v-card-title class="pb-1">
      {{ group.groupName }}
    </v-card-title>

    <v-card-subtitle>
      {{ $t('groups.createdBy') }} {{ group.creatorDisplayName || group.creatorUsername }}
    </v-card-subtitle>

    <v-card-text class="py-2">
      <div class="text-body-2 group-description">
        {{ group.groupDescription || $t('groups.noDescription') }}
      </div>

      <div class="d-flex mt-3" style="gap: 1.5rem;">
        <div class="text-caption">
          <v-icon size="small" class="mr-1">mdi-account-group</v-icon>
          {{ group.memberCount }} {{ $t('groups.members') }}
        </div>
        <div class="text-caption">
          <v-icon size="small" class="mr-1">mdi-post</v-icon>
          {{ group.postCount }} {{ $t('groups.postsCount') }}
        </div>
      </div>
    </v-card-text>

    <v-card-actions>
      <v-btn
        v-if="!group.userRole"
        color="primary"
        variant="elevated"
        size="small"
        @click.stop="joinGroup"
        :loading="joining"
      >
        <v-icon start>mdi-plus</v-icon>
        {{ $t('groups.join') }}
      </v-btn>
      <v-btn
        v-else
        color="primary"
        variant="outlined"
        size="small"
        @click.stop="$emit('click', group)"
      >
        {{ $t('groups.open') }}
      </v-btn>
      
      <v-spacer></v-spacer>
      
      <v-btn
        v-if="group.userRole && group.userRole !== 'admin'"
        variant="text"
        size="small"
        color="error"
        @click.stop="leaveGroup"
        :loading="leaving"
      >
        {{ $t('groups.leave') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup>
/* eslint-disable */
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import api from '../services/api'

const { t } = useI18n()

const props = defineProps({
  group: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['click', 'joined', 'left'])

const joining = ref(false)
const leaving = ref(false)

const defaultCover = 'https://picsum.photos/seed/' + props.group.groupId + '/400/200'

const roleColor = computed(() => {
  switch (props.group.userRole) {
    case 'admin': return 'error'
    case 'moderator': return 'warning'
    default: return 'primary'
  }
})

const joinGroup = async () => {
  joining.value = true
  try {
    const response = await api.post(`/groups/${props.group.groupId}/members`)
    if (response.data.success) {
      emit('joined', props.group.groupId)
    }
  } catch (error) {
    console.error('Error joining group:', error)
    alert(error.response?.data?.error || t('common.error'))
  } finally {
    joining.value = false
  }
}

const leaveGroup = async () => {
  if (!confirm(t('groups.leaveConfirm'))) return
  
  leaving.value = true
  try {
    const response = await api.delete(`/groups/${props.group.groupId}/members`)
    if (response.data.success) {
      emit('left', props.group.groupId)
    }
  } catch (error) {
    console.error('Error leaving group:', error)
    alert(error.response?.data?.error || t('common.error'))
  } finally {
    leaving.value = false
  }
}
</script>

<style scoped>
.group-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.cursor-pointer {
  cursor: pointer;
}

.group-cover {
  position: relative;
}

.group-cover-overlay {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.group-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #666;
}
</style>